import { TaniumStatus } from '../enums/TaniumStatus';

export class ProjectTanium {
  constructor(
    private readonly computerGroup: string,
    private readonly status: TaniumStatus | null,
    private readonly todoCount: number | null,
    private readonly endpointsCount: number | null,
    private readonly completedAt: Date | null
  ) {}

  getComputerGroup() {
    return this.computerGroup;
  }

  getStatus() {
    return this.status;
  }

  getTodoCount() {
    return this.todoCount;
  }

  getEndpointsCount() {
    return this.endpointsCount;
  }

  getCompletedAt() {
    return this.completedAt;
  }
}
